<template>
	<div v-if="delivery">
		<table class="table table-striped table-condensed">
			<tbody>
				<tr v-if="number && ! delivery.sentLater">
					<td colspan="2" style="background-color: #f9f9f9;">
						<strong>Delleverans {{ number }}</strong>
					</td>
				</tr>
				<tr v-if="delivery.sentLater">
					<td colspan="2" class="order-id-wrap">
						<strong>Skickas senare</strong>
					</td>
				</tr>
				<tr v-if="delivery.timestamp">
					<td>
						Skickad
					</td>
					<td style="width: 100%;">
						{{ formatTimestamp(delivery.timestamp) }}
					</td>
				</tr>
			</tbody>
		</table>
		<div>
			<order-status-entry-list v-if="showStatuses" :order="order" :statusEntries="delivery.statusEntries" />
			<div class="panel-body" style="border-top: 1px solid #eee">
				<order-row v-for="row in delivery.rows" :row="row" :key="row.id" :activeStatus="isActive"/>
			</div>
		</div>
	</div>

</template>

<script>
import PHPDate from 'PHPDate';
export default {
	props: {
		order: {
			type: Object,
			default: () => null,
		},
		delivery: {
			type: Object,
			default: () => null,
		},
		number: {
			type: Number,
			default: null,
		},
		showStatuses: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		isActive() {
			return !(this.delivery.timestamp || this.order.statusCode == 0);
		}
	},
	methods: {
		formatTimestamp (timestamp) {
			return PHPDate('Y-m-d H:i', timestamp);
		},
	},
};
</script>
